import { notification } from 'antd';
import { unix } from 'moment';
import _ from 'lodash';
import sha1 from 'js-sha1';
import XLSX from 'xlsx';
import BigNumber from 'bignumber.js';
import consts from '../consts';
import axios from 'axios';
import qs from 'qs';

const Hash = require('eth-lib/lib/hash');
const BN = require('bn.js');

// let timeoutID;
const showNotification = (message = 'title', description = 'description', type = 'success') => {
  notification[type]({
    message,
    description,
  });
};

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
// const clone = (obj) => Object.assign({}, obj);

const renameKey = (object, key, newKey) => {
  const clonedObj = { ...object };
  const targetKey = clonedObj[key];
  delete clonedObj[key];
  clonedObj[newKey] = targetKey;
  return clonedObj;
};

const handleVietnamese = (str) => {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
  str = str.replace(/Đ/g, 'D');
  // Some system encode vietnamese combining accent as individual utf-8 characters
  // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  // Remove extra spaces
  // Bỏ các khoảng trắng liền nhau
  str = str.replace(/ + /g, ' ');
  str = str.trim();
  // Remove punctuations
  // Bỏ dấu câu, kí tự đặc biệt
  str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, ' ');
  return str;
};

const formatCurrency = (currency) => trimRightZeroAndDot(new BigNumber(currency).toFormat(8));

const convert_aobj2aoa = (aobj) => window._.map(aobj,
  (obj) => window._.reduce(obj, (result, v, _) => [...result, v], []));

const addHeader = (data, header) => {
  // header = header.map(col => window._.startCase(window._.toLower(col)));
  data.unshift(header);
  return data;
};

const trimAll = (obj) => {
  if (window._.isArray(obj)) {
    console.log('please pass object here! src/common/utils.js:29');
    return;
  }

  window._.forEach(obj, (value, key) => {
    if (typeof obj[`${key}`] === 'object') {
      trimAll(obj[`${key}`]);
    } else {
      if (key !== `${key}`.trim()) {
        delete obj[`${key}`];
        key = `${key}`.trim();
      }
      if (typeof value === 'string') {
        obj[`${key}`] = window._.trim(value);
      }
    }
  });
};

const paddingZeros = (num, count = 19) => ('0'.repeat(count) + num).substr(-count, count);
const trimRightZero = (num) => (`${num}`.split('.').length === 2 ? window._.trimEnd(num, '0') : `${num}`);
const trimDot = (num) => window._.trimEnd(`${num}`, '.');
const trimRightZeroAndDot = (num) => trimDot(trimRightZero(num));
const isBuyOrder = (tradeType) => consts.ORDER_TRADE_TYPE_BUY === tradeType;
const isSellOrder = (tradeType) => consts.ORDER_TRADE_TYPE_SELL === tradeType;

// Loai lenh
const parseOrderType = (type) => {
  switch (type) {
    case consts.ORDER_TYPE_LIMIT:
      return 'Giới hạn';
    case consts.ORDER_TYPE_MARKET:
      return 'Thị trường';
    case consts.ORDER_TYPE_STOP_LIMIT:
      return 'Giới hạn dừng';
    case consts.ORDER_TYPE_STOP_MARKET:
      return 'Stop Market';
    default:
      return '';
  }
};

const parseTradeType = (type) => {
  switch (type) {
    case consts.ORDER_TRADE_TYPE_BUY:
      return 'Mua';
    case consts.ORDER_TRADE_TYPE_SELL:
      return 'Bán';
    default:
      return '';
  }
};

const parseTransType = (type) => {
  switch (type) {
    case consts.TRANSACTION_TYPE_DEPOSIT:
      return 'Nạp';
    case consts.TRANSACTION_TYPE_WITHDRAW:
      return 'Rút';
    default:
      return 'Nạp';
  }
};

const parseTranStatus = (type) => {
  switch (type) {
    case consts.TRANSACTION_STATUS_SUCCESS:
      return 'Thành công';
    case consts.TRANSACTION_STATUS_PENDING:
      return 'Đang chờ xử lý';
    case consts.TRANSACTION_STATUS_SUBMITTED:
      return 'Đã gửi';
    case consts.TRANSACTION_STATUS_ERROR:
      return 'Lỗi';
    case consts.TRANSACTION_STATUS_CANCEL:
      return 'Đã hủy';
    case consts.TRANSACTION_STATUS_REJECTED:
      return consts.TRANSACTION_STATUS_CANCEL_STR;
    default:
      return '';
  }
};

const parseOrderStatus = (type) => {
  switch (type) {
    case consts.ORDER_STATUS_STOPPING:
      return 'Đang dừng';
    case consts.ORDER_STATUS_PENDING:
      return 'Đang chờ xử lý';
    case consts.ORDER_STATUS_EXECUTED:
      return 'Đã khớp';
    case consts.ORDER_STATUS_CANCELED:
      return 'Đã hủy';
    case consts.ORDER_STATUS_EXECUTING:
      return 'Đang thực thi';
    default:
      return '';
  }
};

const fillTable = (arr) => {
let newArr = arr;
if(_.isArray(newArr)){
  while(newArr?.length % consts.DEFAULT_PAGE_SIZE !== 0){
    newArr = [...newArr, {}]
  }
  return newArr
}
}

function hash(object) {
  return sha1(JSON.stringify(object));
}

function getCoinName(coins, symbol) {
  return window._.find(coins, ['symbol', symbol]);
}

function resetCacheTimeTVChart() {
  sessionStorage.setItem('currentTimeRequest', '');
  sessionStorage.setItem('previousTimeRequest', '');
}

function upperCaseFirst(input) {
  return window._.upperFirst(input);
}

// base on web3js
/**
 * Checks if the given string is an address
 *
 * @method isAddress
 * @param {String} address the given HEX address
 * @return {Boolean}
 */
function isAddress(address) {
  // check if it has the basic requirements of an address
  if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
    return false;
    // If it's ALL lowercase or ALL upppercase
  } if (/^(0x|0X)?[0-9a-f]{40}$/.test(address) || /^(0x|0X)?[0-9A-F]{40}$/.test(address)) {
    return true;
    // Otherwise check each case
  }
  return checkAddressChecksum(address);
}

/**
 * Checks if the given string is a checksummed address
 *
 * @method checkAddressChecksum
 * @param {String} address the given HEX address
 * @return {Boolean}
 */
var checkAddressChecksum = function (address) {
  // Check each case
  address = address.replace(/^0x/i, '');
  const addressHash = sha3(address.toLowerCase()).replace(/^0x/i, '');

  for (let i = 0; i < 40; i++) {
    // the nth letter should be uppercase if the nth digit of casemap is 1
    if ((parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i]) || (parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i])) {
      return false;
    }
  }
  return true;
};

/**
 * Check if string is HEX, requires a 0x in front
 *
 * @method isHexStrict
 * @param {String} hex to be checked
 * @returns {Boolean}
 */
const isHexStrict = function (hex) {
  return ((_.isString(hex) || _.isNumber(hex)) && /^(-)?0x[0-9a-f]*$/i.test(hex));
};

/**
 * Convert a hex string to a byte array
 *
 * Note: Implementation from crypto-js
 *
 * @method hexToBytes
 * @param {string} hex
 * @return {Array} the byte array
 */
const hexToBytes = function (hex) {
  let truncateHex = hex.toString(16);

  if (!isHexStrict(hex)) {
    throw new Error(`Given value "${hex}" is not a valid hex string.`);
  }

  truncateHex = truncateHex.replace(/^0x/i, '');
  const bytes = [];
  for (let c = 0; c < truncateHex.length; c += 2) {
    bytes.push(parseInt(truncateHex.substr(c, 2), 16));
  }

  return bytes;
};

/**
 * Returns true if object is BN, otherwise false
 *
 * @method isBN
 * @param {Object} object
 * @return {Boolean}
 */
const isBN = function (object) {
  return BN.isBN(object);
};

/**
 * Hashes values to a sha3 hash using keccak 256
 *
 * To hash a HEX string the hex must have 0x in front.
 *
 * @method sha3
 * @return {String} the sha3 string
 */
const SHA3_NULL_S = '0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470';

let sha3 = function (value) {
  if (isBN(value)) {
    value = value.toString();
  }

  if (isHexStrict(value) && /^0x/i.test((value).toString())) {
    value = hexToBytes(value);
  }

  const returnValue = Hash.keccak256(value); // jshint ignore:line

  if (returnValue === SHA3_NULL_S) {
    return null;
  }
  return returnValue;
};

function isNumeric(value) {
  return /^\d+$/.test(value);
}

function convertWeiToETH(value){
  const wei = 1e-18
  return new BigNumber(value).multipliedBy(wei)
}

function isAdmin(pubkey) {
  return pubkey === '03bebf72675ef83d392bfc4562a689507c255ada4a837079db5e10538b929bd941' ||
  pubkey === '03d6c974bb9d75a01feb2f4d35e874b6382bf1dc2f4660389161a2505fdaf5a4ca' ||
  pubkey === '039bcca22948205981f86fa0cc04d521e4f002a84aa0adbb8196a2befb1eb97219' ||
  pubkey === '03b9451a5411bdbbe65bd46fd44cd515594df371965547945964b646eba4cda773' ||
  pubkey === '035bbdc598befe7f3bd18e9116435d6ae9b421fc4ba0fbe1dfab902a9ffefdb068' ||
  pubkey === '03e4c56c327b6f1759ee1b6cb575fc102d701660bacc2ee35f7f15bbd1fa86dc73' ||
  pubkey === '030ce82a17952be5466f9e64c8eb00467c0063ed6a58dde893b90856e9e6226f93' ||
  pubkey === '02e0dbccb5ef16a28e00c5713de24c16bfcd1fa786a8522a94eac383d3969b3e4c';
}

const dumpRequest = ({ file, onSuccess }, callback = void(0)) => {
  const formData = new FormData();
  formData.append('files', file);
  const customAxios = axios.create({
    baseURL: 'https://upload.photocloud.mobilelab.vn',
    headers: {
      'Content-Type': 'multipart/form-data',
      // Origin: 'https://admin.crypto.mobilelab.vn',
    },
    paramsSerializer(params) {
      return qs.stringify(params);
    },
  });
  
  customAxios.post('upload', formData).then((resp) => {
    if (resp.data.uploaded_files.length > 0) {
      if (_.isFunction(callback)) {
        callback(resp.data.uploaded_files[0]);
      }
    }
  });
  onSuccess('ok');
} ;

export default {
  isAdmin,
  isAddress,
  resetCacheTimeTVChart,
  parseTradeType,
  parseTranStatus,
  getCoinName,
  parseTransType,
  isBuyOrder,
  isSellOrder,
  hash,
  trimAll,
  showNotification,
  paddingZeros,
  trimRightZero,
  trimRightZeroAndDot,
  parseOrderType,
  parseOrderStatus,
  upperCaseFirst,
  formatCurrency,
  formatTimeFromUnix: (unixTime, format = 'DD/MM/YYYY') => unix(parseInt(`${unixTime}`.substr(0, 10))).format(format),
  handleExport: (data, nameFile = 'test', extension = 'csv') => {
    if (data.length === 0) {
      showNotification('Notification', 'Please select at least one config before export', consts.TYPE_WARNING);
      return;
    }
    const dataConverted = convert_aobj2aoa([...data]);
    const dataConvertedWithHeader = addHeader(dataConverted, [...Object.keys(data[0])]);
    const workSheet = XLSX.utils.aoa_to_sheet(dataConvertedWithHeader);
    const bookNew = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(bookNew, workSheet, nameFile);
    XLSX.writeFile(bookNew, `${nameFile}.${extension}`);
  },
  renameKey,
  isNumeric,
  // debounceFunction,
  handleVietnamese,
  convertWeiToETH,
  fillTable,
  getBase64,
  dumpRequest,
};
